import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unfold",
  "use": "icon-unfold-usage",
  "viewBox": "0 0 1137 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1137 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unfold\"><path d=\"M0 0h1137.777778v204.8H0V0z m0 409.6h758.499556v204.8H0V409.6z m0 409.6h1137.777778V1024H0v-204.8z m853.333333-563.2L1137.777778 512l-284.444445 204.8V256z\" p-id=\"2974\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol